import { Pipe, PipeTransform } from '@angular/core';
import { AssetStatus } from '@fleet-beat/api';

@Pipe({
  name: 'mapStatus',
})
export class MapStatusPipe implements PipeTransform {
  transform(value: number | string): string {
    return AssetStatus[+value].replace(/([A-Z])/g, ' $1').replace(/^./, function (str: string) {
      return str.toUpperCase();
    });
  }
}
